import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { TickerStrip } from "@/components/TextTicker";

const Color = ({ label, k, t, set }) => (
  <label className="flex items-center justify-between gap-2 text-sm font-semibold text-slate-700">
    {label}
    <input type="color" data-testid={`ticker-${k}`} value={t[k]} onChange={(e) => set({ ...t, [k]: e.target.value })} className="w-12 h-9 rounded-lg border border-slate-200 bg-white" />
  </label>
);

export default function AdminTicker() {
  const [t, setT] = useState(null);
  useEffect(() => {
    api.get("/ticker").then((r) => setT(r.data)).catch(() => {});
  }, []);
  if (!t) return null;
  // Lower seconds = faster; slider shows speed so right = faster
  const speedVal = 123 - t.speed;
  const save = async () => {
    try { setT((await api.put("/admin/ticker", t)).data); toast.success("Shiriti u ruajt"); }
    catch { toast.error("Ruajtja dështoi"); }
  };
  return (
    <div className="bg-white rounded-2xl p-4 border border-slate-100 space-y-3" data-testid="admin-ticker">
      <label className="flex items-center justify-between font-bold text-slate-800">
        Shfaq shiritin në kryefaqe
        <input type="checkbox" data-testid="ticker-enabled" checked={t.enabled} onChange={(e) => setT({ ...t, enabled: e.target.checked })} className="w-5 h-5 accent-emerald-600" />
      </label>
      <textarea data-testid="ticker-text" value={t.text} onChange={(e) => setT({ ...t, text: e.target.value })} rows={2} maxLength={500}
        placeholder="Shkruaj tekstin që ecën…" className="w-full rounded-xl border border-slate-200 p-3 text-sm" />
      <div className="grid grid-cols-2 gap-2">
        <label className="text-sm font-semibold text-slate-700">Fillon më
          <input type="date" data-testid="ticker-start" value={t.start || ""} onChange={(e) => setT({ ...t, start: e.target.value })} className="mt-1 w-full h-10 rounded-xl border border-slate-200 px-2 text-sm" />
        </label>
        <label className="text-sm font-semibold text-slate-700">Mbaron më
          <input type="date" data-testid="ticker-end" value={t.end || ""} min={t.start || undefined} onChange={(e) => setT({ ...t, end: e.target.value })} className="mt-1 w-full h-10 rounded-xl border border-slate-200 px-2 text-sm" />
        </label>
      </div>
      <p className="text-xs text-slate-400 -mt-1">Lëre bosh që të shfaqet pa afat.</p>
      {t.enabled && t.live === false && <p data-testid="ticker-status" className="text-xs font-semibold text-amber-600">Shiriti nuk shfaqet tani (jashtë datave).</p>}
      {t.live && <p data-testid="ticker-status" className="text-xs font-semibold text-emerald-600">Shiriti po shfaqet tani në kryefaqe.</p>}
      <Color label="Ngjyra e shiritit" k="bg" t={t} set={setT} />
      <Color label="Ngjyra e tekstit" k="color" t={t} set={setT} />
      <Color label="Ngjyra e kornizës" k="border" t={t} set={setT} />
      <label className="flex items-center justify-between text-sm font-semibold text-slate-700">
        Shkronja digjitale (si ora)
        <input type="checkbox" data-testid="ticker-digital" checked={t.digital} onChange={(e) => setT({ ...t, digital: e.target.checked })} className="w-5 h-5 accent-emerald-600" />
      </label>
      <label className="block text-sm font-semibold text-slate-700">
        Shpejtësia <span className="text-slate-400 font-normal">(majtas ngadalë · djathtas shpejt)</span>
        <input type="range" data-testid="ticker-speed" min={3} max={120} value={speedVal} onChange={(e) => setT({ ...t, speed: 123 - Number(e.target.value) })} className="w-full accent-emerald-600" />
      </label>
      <label className="block text-sm font-semibold text-slate-700">
        Madhësia e tekstit: {t.size}px
        <input type="range" data-testid="ticker-size" min={10} max={28} value={t.size} onChange={(e) => setT({ ...t, size: Number(e.target.value) })} className="w-full accent-emerald-600" />
      </label>
      <div className="text-xs font-semibold text-slate-400">Pamja paraprake</div>
      <div className="-mx-3"><TickerStrip t={{ ...t, enabled: true, live: true, text: t.text || "Teksti juaj këtu" }} /></div>
      <button data-testid="ticker-save" onClick={save} className="w-full h-11 rounded-xl bg-emerald-600 text-white font-bold">Ruaj</button>
    </div>
  );
}
